module.exports = __webpack_public_path__ + "images/cover_mobile3.2e704fee.png";